



































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsDraftingTable from "@/design-system/patterns/DraftingTable/JdsDraftingTable.vue"
import JdsFieldGroup from "@/design-system/forms/fields/JdsFieldGroup.vue"
import JdsRichRadioGroup from "@/design-system/forms/fields/JdsRichRadioGroup.vue"
import JdsRichRadioOption from "@/design-system/forms/fields/JdsRichRadioOption.vue"
import JdsCheckboxGroup from "@/design-system/forms/fields/JdsCheckboxGroup.vue"
import JdsCheckbox from "@/design-system/forms/fields/JdsCheckbox.vue"
import JdsSelectField from "@/design-system/forms/fields/JdsSelectField.vue"
import JdsSelectFieldOption from "@/design-system/forms/fields/JdsSelectFieldOption.vue"
import JdsInlineTextField from "@/design-system/forms/fields/JdsInlineTextField.vue"

@Component({
    components: {
        JdsInlineTextField,
        JdsSelectFieldOption,
        JdsSelectField,
        JdsCheckbox,
        JdsCheckboxGroup,
        JdsRichRadioOption,
        JdsRichRadioGroup, JdsFieldGroup, JdsDraftingTable, JdiDocs, JdiPreview, JdiContent}
})
export default class FormsOverview extends Vue {
    form = {
        name: 'Jobi Bot',
        address: {
            street: 'Vuorikatu\n16 A 7-8',
            city: 'Helsinki',
            postcode: '00100',
            country: 'Finland',
        },
        region: null,
        donation: 500.00,
        url: '',
        credit: {
            who: 'me',
            custom: ''
        },
        edition: 'vortex',
        subscription: null,
        gift: null,
        terms: false,
        privacy: false,
    }

    saving = false
    forceFail = false

    giftOptions = [{id: 1, label: 'Wrap me up!'}, {id: 2, label: "Don't gift wrap"}]

    get formData () {
        return JSON.stringify(this.form, null, 4)
    }

    save(res: Function, err: Function) {
        setTimeout(() => {
            if (this.forceFail) {
                err()
            } else {
                res()
            }
        }, 500)
    }
}
